import { questNumberLabel, questPath, type JobQuest } from "../types";
import { PaperPins, QuestInsignia } from "./QuestPaperDecor";
import {
  QuestBalance,
  QuestStatus,
  RankBadge,
  SkillTags,
} from "./QuestPrimitives";

export function QuestCard({ quest }: { quest: JobQuest }) {
  return (
    <article className="jq-card jq-paper">
      <PaperPins />
      <div className="jq-card-meta jq-card-ticket">
        <span className="jq-eyebrow">
          QUEST #{questNumberLabel(quest.questNumber)}
        </span>
        <QuestStatus quest={quest} />
      </div>
      <div className="jq-card-body">
        <div className="jq-card-emblem">
          <QuestInsignia />
          <RankBadge rank={quest.rank} />
        </div>
        <div className="jq-card-heading">
          <div>
            <p className="jq-company">依頼主 / {quest.company}</p>
            <h2>
              <a href={questPath(quest.questNumber)}>{quest.title}</a>
            </h2>
          </div>
        </div>
        {quest.isDemo && (
          <span className="jq-sample-label">SAMPLE / 架空のQuest</span>
        )}
        <p className="jq-card-description">{quest.description}</p>
        <p className="jq-card-target">
          {quest.target}
          <span aria-hidden="true"> / </span>
          {quest.workLocation}
        </p>
        <div>
          <p className="jq-field-label">REQUIRED SKILLS / 必須スキル</p>
          <SkillTags skills={quest.requiredSkills} />
        </div>
        <div className="jq-card-reward">
          <span className="jq-field-label">REWARD / 報酬</span>
          <strong>{quest.reward}</strong>
        </div>
        <p className="jq-field-label">企業が選考で重視すること</p>
        <QuestBalance quest={quest} />
      </div>
      <a
        className="jq-card-link"
        href={questPath(quest.questNumber)}
        aria-label={`${quest.title}の詳細を見る`}
      >
        依頼書を開く<span aria-hidden="true">↗</span>
      </a>
    </article>
  );
}
